// extracted by mini-css-extract-plugin
export default {"petImg":"pet-details_petImg__6t88r"};